import React, { Fragment } from 'react';
import * as R from 'ramda';
import Skeleton from 'components/general/Skeleton/Skeleton';

const SkeletonParagraph: React.SFC<PropsDef> = ({ lines, types }) => (
  <Fragment>
    {R.times(
      n => (
        <Skeleton
          width={[95, 100]}
          unit="%"
          key={`skeleton-para-${n}`}
          types={types}
        />
      ),
      lines,
    )}
  </Fragment>
);

SkeletonParagraph.defaultProps = {
  types: [],
  lines: 6,
};

interface PropsDef {
  lines?: number;
  types?: string[];
}

export default SkeletonParagraph;

